export default "__VITE_ASSET__DKvzlaID__"